import { render, staticRenderFns } from "./MyAppointment.vue?vue&type=template&id=b1a96dba&scoped=true&"
import script from "./MyAppointment.vue?vue&type=script&lang=js&"
export * from "./MyAppointment.vue?vue&type=script&lang=js&"
import style0 from "./MyAppointment.vue?vue&type=style&index=0&id=b1a96dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a96dba",
  null
  
)

export default component.exports